module.exports = __webpack_public_path__ + "static/media/add.8ebb20c3.svg";